export default "__VITE_ASSET__2b0f5811__"